import { render, staticRenderFns } from "./fankui.vue?vue&type=template&id=b372a322"
import script from "./fankui.vue?vue&type=script&lang=js"
export * from "./fankui.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports